import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { Button } from 'controls'
import { TableToCard } from 'controls/Table'
import Modal from 'controls/Modal'
import { PlayAudio } from 'components/Media'
import { CALL_TRACKING_TYPE_BIBLIO } from 'app/services/seo'

import { formattedTime } from 'services/utils'

import { RESULTS_PER_PAGE } from './config'

import styles from './styles'

class Portals extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      audioUrl: null,
      showModal: false,
      isPlayAudio: false,
      audioName: ''
    }
  }

  render() {
    const {
      dataCalls,
      loading,
      handleTablePageChange,
      currentTablePage,
      pageCount: count
    } = this.props
    const { showModal, isPlayAudio, audioName, audioUrl } = this.state

    const pageCount = Math.ceil(count / RESULTS_PER_PAGE)

    const fields = [
      // {
      //   renderExtraContent: item => {
      //     return <span>Soy extra content</span>
      //   }
      // },
      {
        key: 'startDate',
        caption: 'Fecha',
        headerCard: true,
        width: '15%',
        render: item => <div>{moment(item.startDate).fromNow()}</div>
      },
      {
        key: 'fromNumber',
        caption: 'Número teléfonico',
        width: '15%'
      },
      {
        key: 'status',
        caption: 'Estatus',
        width: '15%',
        render: item => {
          const status =
            item && item.status && CALL_TRACKING_TYPE_BIBLIO[item.status]
          const content = status ? status : item
          return content
        }
      },
      {
        key: 'callDuration',
        caption: 'Duración de la llamada',
        width: '15%',
        headerCard: true,
        render: item => <div>{formattedTime(item.callDuration)} min</div>
      },
      {
        key: 'downloadedAudioFile',
        caption: 'Escuchar llamada',
        width: '20%',
        render: item => {
          if (!item.downloadedAudioFile) {
            return <div>No hay audio</div>
          }
          return (
            <div>
              <Button
                onClick={() =>
                  this.setState({
                    audioUrl: item.downloadedAudioFile,
                    audioName: item.uuid || '',
                    showModal: true
                  })
                }
              >
                <u>Escuchar audio</u>
              </Button>
              <style jsx>{styles}</style>
            </div>
          )
        }
      },
      {
        key: 'downloadedAudioFile',
        caption: 'Descargar llamada',
        width: '20%',
        hiddeOnMobile: true,
        headerCard: false,
        renderContentCard: () => null,
        render: item => {
          if (!item.downloadedAudioFile) {
            return <div>No hay audio</div>
          }
          return (
            <div className="wrapper-btn-download">
              <a
                href={item.downloadedAudioFile}
                download={item.downloadedAudioFile}
                target="_blanck"
                className="btn-download-audio"
              >
                <Button>
                  <u>Descargar</u>
                </Button>
              </a>
              <span className="message">
                Sólo disponible la versión de escritorio
              </span>

              <style jsx>{styles}</style>
            </div>
          )
        }
      }
    ]

    return (
      <div className="container-portals">
        <Modal
          isOpen={showModal}
          onClose={() =>
            this.setState({ showModal: false, isPlayAudio: false })
          }
        >
          <PlayAudio
            isPlay={isPlayAudio}
            events={{
              onPlay: () => this.setState({ isPlayAudio: true }),
              onPause: () => this.setState({ isPlayAudio: false })
            }}
            audio={{
              name: audioName,
              url: audioUrl
            }}
            config={{
              hiddeDownloadInMobile: true
            }}
          />
        </Modal>
        <div className="wrapper-table-to-card">
          <TableToCard
            items={dataCalls}
            fields={fields}
            loading={loading}
            showExtraContent={false}
            showPaginate
            currentPage={currentTablePage}
            pageCount={pageCount}
            onPageChange={index =>
              handleTablePageChange(index, RESULTS_PER_PAGE)
            }
          />
        </div>

        <style jsx>{styles}</style>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    dataCalls: state.portals.tableCall.dataTableCalls,
    pageCount: state.portals.generalParams.count,
    loading: state.portals.tableCall.loading
  }
}

export default connect(mapStateToProps)(Portals)
